import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_439';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Indique el 50% del valor de los pagos realizados  ', listHelp: ['439'] }
];

@Component({
  selector: 'app-descuentos-pagos-ica-modal',
  templateUrl: './descuentos-pagos-ica-modal.component.html',
  styleUrls: ['./descuentos-pagos-ica-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class DescuentosPagosICAModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<DescuentosPagosICAModalComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected inicializeModelo() {
    // if(this.model.doc.cuerpo.cs_id_378 == undefined)this.model.doc.cuerpo.cs_id_378=null;
    if (this.model.doc.cuerpo.cs_id_379 == undefined) this.model.doc.cuerpo.cs_id_379 = "0";
  }

  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {

      case 379: this.OperacionCs379(); break;

    }
  }
  OperacionCs379() {
    this.model.doc.cuerpo.cs_id_379 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_379, true);
    const cas379 = this.model.doc.cuerpo.cs_id_379
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas379, "0")) {
      this.dNotificacionServicio.mostrarDialogoInformacion("El valor de los pagos realizados no puede ser cero");
      return
    }
  }

  public operacionCs153(): void {
    this.model.doc.cuerpo.cs_id_153 = this.model.doc.cuerpo.cs_id_153;
    this.model.doc.cuerpo.cs_id_154 = this.model.doc.cuerpo.cs_id_153;
  }

  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {
    // if(this.model.doc.cuerpo.cs_id_378 == undefined)this.model.doc.cuerpo.cs_id_378=null;
    if (this.model.doc.cuerpo.cs_id_379 == undefined) this.model.doc.cuerpo.cs_id_379 = "0";
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS: number): boolean {
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive() {

  }

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance() {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (this.indexStepper > Number(casIndicadorAvance)) {
      let indexS = this.indexStepper + 1;
      while (!this.validateStepHabilitado(indexS)) {
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = indexS.toString();
    }
    if (this.indexStepper == this.stepsList.length - 1) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?: boolean) {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (forceUpdateStepper) {
      this.changeStep(index);
      this.updateIndicadorAvance();
    } else if (this.validateStepHabilitado(index)) {
      let indexCalc = index - 1;
      if (indexCalc <= Number(casIndicadorAvance)) {
        this.changeStep(index);
        this.updateIndicadorAvance();
      } else {
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1=" + (indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true; }
  }

  public closeModal() {
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar() {
    this.saveModel.emit(true);
    if (this.indexStepper == this.stepsList.length - 1) {
      this.closeModal();
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/descuentos/descuentos-pagos-ica-modal/descuentos-pagos-ica-modal.component.ts